import { InvoiceList } from './Invoices';

// Read-only view of orders/invoices (no create/edit, rows open preview).
export default function ViewInvoices() {
  return <InvoiceList readOnly />;
}